import React from "react";
import { useTranslation } from "react-i18next";
import { getStrTime } from "../utils/utils";

/**
 * Render an HTML object to display the ETA timer in the waiting line. 
 * @param text : text translated which is displayed before the rank
 * @param token: token decoded
 * @param waitingTime: time to wait ( in openIn use case )
 * @param className: classname of HTML field displayed
 * @param {} param0 
 */
export default function NeoEta({ className='', wording={}, waitingTime=null }) {
    const { t } = useTranslation();

    // If null or 0
    if (!waitingTime) {
        return null;
    }

    let waitMinutes = waitingTime / 60;
    let extraTime = waitMinutes % 5;
    let minTime = waitMinutes - extraTime;
    let maxTime = minTime + 5;
    let strMin = getStrTime(minTime*60000, t, false);
    let strMax = getStrTime(maxTime*60000, t, false);


    const { waiting_time, wait_5_minutes, wait_2_hours, wait_time } = wording;

    //Display the 5 minutes before and after
    if(maxTime <= 5) {
        return (
            <div className={className}>
                {waiting_time}<span className='queue-waiting-time-eta'> {wait_5_minutes}</span>
            </div>
        );
    }

    if (maxTime > 120) {
        return (
            <div className={className}>
                {waiting_time}<span className='queue-waiting-time-eta'> {wait_2_hours}</span>
            </div>
        );
    }

    return (
        <div className={className}>
            {waiting_time}<span className='queue-waiting-time-eta'> {t(wait_time, {
                min: strMin,
                max: strMax
            })}</span>
        </div>
    );
}
